import RestService from "~/core/services/rest.service";
import type { UserPayloadPatch } from "~/modules/user/models/UserPayloadPatch.interface";
import type { UserSession } from "~/modules/user/models/UserSession.interface";

export class UserService extends RestService {
  protected BASE_URL = "users";

  /**
   * Retrieve current user
   */
  getCurrentUser(): Promise<UserSession> {
    return this.$apiV2.get(this.getCurrentUserPath());
  }

  /**
   * Patch the current user
   * @param user
   */
  patchCurrentUser(user: UserPayloadPatch): Promise<UserSession> {
    return this.$apiV2.patch(this.getCurrentUserPath(), user);
  }

  /**
   * Set session
   * @param code
   * @param redirectUri
   */
  setSession(code: string, redirectUri: string): Promise<UserSession> {
    const params = {
      code,
      redirectUri,
    };

    return this.$api.get(`${this.BASE_URL}/session`, { params });
  }

  /**
   * Return the path of the current user
   */
  private getCurrentUserPath(): string {
    return `${this.BASE_URL}/me`;
  }
}

export default new UserService();
